import React, { useState } from "react";
import { addCommas } from "@persian-tools/persian-tools";
import ColorSchema from "../kits/Color";
import { CloseIcon, TickIcon, TrashIcon } from "../kits/Icons";
import { TimeStampToJalali } from "../../utils/helperFunction";
import useAxios from "../../services/useAxios";
import { showSwalQuestion, showSwalSuccess } from "../../utils/swal";
import { CustomTooltip } from "../kits/tooltip/CustomTooltip.jsx";

export default function InventoryItem({
  data,
  setUpdater,
  setOpenModal,
  setSelectedRecord,
}) {
  console.log("object", data);
  const { execute: cancelRecord } = useAxios("record/cancellation_record");
  const [loading, setLoading] = useState(false);
  const connectToCancelApi = (id) => {
    showSwalQuestion("قبض مورد نظر باطل شود؟").then((res) => {
      if (res.isConfirmed) {
        setLoading(true);
        cancelRecord({ record_id: id }).then((res) => {
          if (res.status === 1) {
            showSwalSuccess("ابطال قبض با موفقیت انجام شد.");
            setUpdater((prev) => !prev);
          }
          setLoading(false);
        });
      }
    });
  };

  return (
    <div
      className={`inventory-item d-flex flex-wrap my-2 ${
        data?.status == -1 ? "inventory-item-status" : ""
      } ${data?.check_in_out_type == "2" ? "in" : "out"}`}
    >
      <div className={`flex-grow-1 my-1 p-2 title `}>
        <h6 className="title-header">عنوان محصول</h6>

        <p className="text-center pt-2 mt-3 ">{data?.product[0]?.title} </p>
      </div>
      <div className={`flex-grow-1 my-1 p-2 count `}>
        <h6 className="title-header">تعداد</h6>

        <p className="text-center pt-2 mt-3 ">{addCommas(data?.count)}</p>
      </div>
      <div className={`flex-grow-1 my-1 p-2 count `}>
        <h6 className="title-header">نوع قبض</h6>
        <p className="text-center pt-2 mt-3 ">
          {/* {data?.type == "1" ? "ورودی" : "خروجی"} */}
          {data?.check_in_out_type == "2"
            ? "ورودی"
            : data?.check_in_out_type == "1"
            ? "خروجی"
            : "__"}
        </p>
      </div>
      <div className={`flex-grow-1 my-1 p-2 count `}>
        <h6 className="title-header">زمان ثبت</h6>

        <p className="text-center pt-2 mt-3 ">
          {/* {TimeStampToJalali(parseInt(data?.mtm) * 1000, "YYYY/MM/DD")} */}
          {TimeStampToJalali(parseInt(data?.check_time) * 1000, "YYYY/MM/DD")}
        </p>
      </div>
      <div className={`flex-grow-1 my-1 p-2 count `}>
        <h6 className="title-header">
          {data?.check_in_out_type == "2"
            ? "زمان ورود"
            : data?.check_in_out_type == "1"
            ? "زمان خروج"
            : "__"}
        </h6>

        <p className="text-center pt-2 mt-3 ">
          {" "}
          {TimeStampToJalali(parseInt(data?.insert_tm) * 1000, "YYYY/MM/DD")}
          {/* {TimeStampToJalali(parseInt(data?.entrance_tm) * 1000, "YYYY/MM/DD")} */}
        </p>
      </div>

      <div className={`flex-grow-1 my-1 p-2 title `}>
        <h6 className="title-header">نام کاربر ثبت کننده</h6>

        {/* <p className="text-center pt-2 mt-3 ">سید محدحسین کیاالحسینی</p> */}
        <p className="text-center pt-2 mt-3 ">
          {data?.muid_user[0]?.fname != "" && data?.muid_user[0]?.lname != ""
            ? data?.muid_user[0]?.fname + " " + data?.muid_user[0]?.lname
            : "---"}
        </p>
      </div>

      <div className={`flex-grow-1 my-1 p-2 count `}>
        <h6 className="title-header">شناسه سفارش</h6>

        <p className="text-center pt-2 mt-3 ">
          {/* {data?.order_code != "" ? data?.order_code : "---"} */}
          {data?.order[0]?.id}
        </p>
      </div>
      <div className={`flex-grow-1 my-1 p-2 count `}>
        <h6 className="title-header">جایگاه</h6>

        {/* <p className="text-center pt-2 mt-3 ">{data?.placement}</p> */}
        <p className="text-center pt-2 mt-3 ">{data?.position}</p>
      </div>
      <div
        className={`px-2 pt-3 pb-1 w-100 d-flex align-items-center property `}
      >
        <h6 className="">صفتها</h6>

        <p className="ps-4 flex-grow-1">
          {/* {data?.product_info?.options?.map(
            (v, i) =>
              `${v.title}(${v.value}) ${
                i < data?.product_info?.options?.length - 1 ? ", " : ""
              }`
          )} */}
          {data?.properties?.map(
            (v, i) =>
              `${v.name}(${v.value}) ${
                i < data?.properties.length - 1 ? ", " : ""
              }`
          )}
        </p>
      </div>
      {+data?.status !== -1 && (
        <div className="w-100 d-flex justify-content-end m-1">
          <CustomTooltip title="ابطال" placement="top" color="secondary_custom">
            <div
              onClick={(e) => {
                if (!loading) {
                  connectToCancelApi(data?.id);
                }
              }}
            >
              <TrashIcon
                color={ColorSchema.danger_custom}
                containerIconClassName="cursor-pointer"
                style={{ width: 20, height: 20 }}
              />
            </div>
          </CustomTooltip>
          {/* {data?.status == -1 && (
          <TickIcon
            containerIconClassName="cursor-pointer"
            color={ColorSchema.success_custom}
            style={{ width: 20, height: 20 }}
          />
        )} */}
          {+data?.check_in_out_type === 2 && +data?.count !== 0 && (
            <CustomTooltip
              title="خروج از انبار"
              placement="top"
              color="secondary_custom"
            >
              <div
                onClick={(e) => {
                  setOpenModal(true);
                  setSelectedRecord(data);
                }}
              >
                <CloseIcon
                  containerIconClassName="cursor-pointer"
                  color={ColorSchema.danger_custom}
                  style={{ width: 20, height: 20 }}
                />
              </div>
            </CustomTooltip>
          )}
        </div>
      )}
    </div>
  );
}
